import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Inbox as InboxIcon } from "lucide-react";
import AppHeader from "@/components/AppHeader";
import api from "@/lib/api";

export default function Inbox() {
  const nav = useNavigate();
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get("/inbox").then(({ data }) => setRows(data)).catch(() => setRows([])); api.post("/notifications/read").catch(() => {}); }, []);
  return (
    <div className="min-h-screen" style={{ background: "var(--bg)", color: "var(--text)" }}>
      <AppHeader title="Inbox" />
      <div className="max-w-2xl mx-auto px-4 py-8">
        <h1 className="font-display font-bold text-2xl flex items-center gap-2"><InboxIcon className="w-6 h-6 text-primary-c" /> Inbox</h1>
        <p className="text-sm mt-1 mb-5" style={{ color: "var(--text-2)" }}>Messages from organizers of your events.</p>
        {rows === null ? <div className="py-16 flex justify-center"><Loader2 className="w-6 h-6 animate-spin text-primary-c" /></div>
          : rows.length === 0 ? <p className="text-sm text-center py-12" style={{ color: "var(--text-2)" }} data-testid="inbox-empty">No messages yet.</p>
          : <div className="space-y-3" data-testid="inbox-list">{rows.map((m) => (
            <div key={m.broadcast_id} className="rounded-2xl glow-border p-4" style={{ background: "var(--surface)" }} data-testid={`inbox-msg-${m.broadcast_id}`}>
              <div className="flex items-start justify-between gap-2 flex-wrap">
                <span className="font-bold break-words min-w-0">{m.title}</span>
                <span className="text-[11px] mono" style={{ color: "var(--text-2)" }}>{new Date(m.created_at).toLocaleString()}</span>
              </div>
              <div className="text-xs mt-0.5" style={{ color: "var(--text-2)" }}>From {m.from_name || "Organizer"}{m.tournament_name ? ` · ${m.tournament_name}` : ""}</div>
              <p className="text-sm mt-2 whitespace-pre-wrap break-words">{m.body}</p>
              {m.tournament_id && <button data-testid={`inbox-open-${m.broadcast_id}`} onClick={() => nav(`/t/${m.tournament_id}`)} className="text-xs font-bold text-primary-c mt-2">Open tournament →</button>}
            </div>
          ))}</div>}
      </div>
    </div>
  );
}
